import { useState } from 'react';
import * as React from 'react';
import { Button } from '../../../../web/components-v2/Button';
import {
	Dialog,
	DialogBody,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../../web/components-v2/Dialog';
import { Field, FieldLabel } from '../../../../web/components-v2/Field';
import { Input } from '../../../../web/components-v2/Input';
import { styleSheet } from '../styles';

interface IProps {
	onClickToClose: () => void;
	onClickToSave: (value: string) => void;
}

export const SetCustomValueModal: React.FC<IProps> = ({ onClickToClose, onClickToSave }) => {
	const [value, setValue] = useState('1');
	return (
		<Dialog open={true} onOpenChange={open => !open && onClickToClose()}>
			<DialogPopup forceBackdrop>
				<DialogHeader>
					<DialogTitle>Set Custom Value</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<Field styles={[styleSheet.field]}>
						<FieldLabel htmlFor='custom-value'>Value</FieldLabel>
						<Input
							id='custom-value'
							min={1}
							onChange={({ target }) => setValue(target.value)}
							type='number'
							value={value}
						/>
					</Field>
				</DialogBody>
				<DialogFooter>
					<Button onClick={() => onClickToSave(value)}>Save</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};
